import * as React from "react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { showNotification } from "../../actions";
import { defineMessage, FormattedMessage } from "react-intl";

type Props = {
    url: string;
};

export default function CopyLinkButton({ url }: Props) {
    const dispatch = useDispatch();
    const [isOpen, setOpen] = useState(false);

    return (
        <React.Fragment>
            <IconButton color="primary" size="small" onClick={() => setOpen(true)}>
                <FontAwesomeIcon icon="share-alt" />
            </IconButton>
            <Dialog open={isOpen}>
                <DialogTitle>
                    <FormattedMessage id="shareJoinLink" defaultMessage="Share join link" />
                </DialogTitle>
                <DialogContent>
                    <TextField fullWidth size="small" value={url} />
                    <Button
                        variant="contained"
                        onClick={async () => {
                            try {
                                await navigator.clipboard.writeText(url);
                                dispatch(
                                    showNotification({
                                        message: defineMessage({
                                            id: "joinLinkCopied",
                                            defaultMessage: "Join link has been copied to clipboard",
                                        }),
                                    }),
                                );
                            } catch (e) {
                                dispatch(
                                    showNotification({
                                        message: defineMessage({
                                            id: "cantUseClipboard",
                                            defaultMessage: "Clipboard copy error",
                                        }),
                                        variant: "error",
                                    }),
                                );
                                console.error(e);
                            }
                        }}
                        color="primary"
                        style={{ marginTop: "0.5em" }}
                    >
                        <FormattedMessage id="copyToClipboard" defaultMessage="Copy to clipboard" />
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="secondary">
                        <FormattedMessage id="close" defaultMessage="Close" />
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
